import { makeWebchatWidgetProvider } from 'modules/webchat/infra/providers';

import MountWebchatUseCase from './implementations/MountWebchatUseCase';

let instance: MountWebchatUseCase | null = null;

export default function makeMountWebchatUseCase() {
  if (!instance) {
    instance = new MountWebchatUseCase(makeWebchatWidgetProvider());
  }

  return instance;
}
